/**
 * Handle Session Storage
 *
 * @param container {HTMLElement} container element
 */
const MarketingAlertStripeMob = (container) => {
  const close = container.querySelector(".js-marketingAlertStrip-close");
  const { id } = container.dataset;

  const isHidden = sessionStorage.getItem(id) === "true";

  if (!isHidden) {
    container.classList.remove("hidden");
  }

  const setMobileBackgroundImage = () => {
    const backgroundElement = document.querySelector(".js-marketingAlertStripe-mob") as HTMLElement;
    if (!backgroundElement) return;

    const imageUrl = backgroundElement.dataset.image;
    const retinaImageUrl = backgroundElement.dataset.imageRetina;
    const isRetina = window.devicePixelRatio > 1.1;

    const img = new Image();
    img.src = isRetina && retinaImageUrl ? retinaImageUrl : imageUrl;

    img.onload = () => {
      backgroundElement.style.backgroundImage = `url(${img.src})`;
      backgroundElement.style.backgroundSize = `${img.width / (isRetina ? 2 : 1)}px auto`;
    };
  };

  // Spustí se při načtení stránky i při změně velikosti okna
  setMobileBackgroundImage();
  window.addEventListener("resize", setMobileBackgroundImage);

  close.addEventListener("click", () => {
    sessionStorage.setItem(id, "true");
    container.classList.add("hidden");
  });
};

export default MarketingAlertStripeMob;
